/**
 * Build version of the running bundle.
 *
 * The value is baked in at build time by CRA from `REACT_APP_VERSION`
 * (Dockerfile.prod passes it as a build-arg, CI resolves it from the git tag).
 * Local/dev builds have no tag, so nothing is injected — in that case we render
 * a literal `dev` marker instead of a blank or a stale hardcoded number.
 */
export const DEV_VERSION_LABEL = 'dev';

export const getAppVersion = (): string => {
  const raw = process.env.REACT_APP_VERSION;
  const version = typeof raw === 'string' ? raw.trim() : '';

  if (!version) {
    return DEV_VERSION_LABEL;
  }

  return version.startsWith('v') ? version : `v${version}`;
};
